import { NavigationButton } from '@components/atoms/NavigationButton/NavigationButton';
import React from 'react'
import { useNavigate } from 'react-router-dom';

/**
 * This error page will display upon form submission failure
 */
const InternalServerError: React.FC = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className="errorBox  h-[211px] w-[100%] border-[10px] border-[#D70D0D] px-[32px] py-auto">
        <p className="errorMessage flex h-[100%] items-center justify-center text-[41px] font-semibold leading-[57px]">
            Oops, something went wrong
        </p>
      </div>
      <div className="errorInformation mt-[27px] h-[180px] w-[308px] sm:w-[100%]">
        <p className="leading[30.17px] text-[24px] font-bold mb-[18px]">
          Please try again
        </p>
        <div className="flex items-start">
        <NavigationButton
            type="primary"
            text={"Go back"}
            navigateToDestination={() => navigate(-1)}
            className="rounded-md bg-button-default shadow-[0px_2px_6px_0px_rgba(0, 0, 0, 0.30)]"
            fontWeight='semi-bold'
          />
        </div>
      </div>
    </>
  );
}

export default InternalServerError